module.exports = __webpack_public_path__ + "img/appdownload-bg@2x.97e51a57.png";